export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8097.50304161.jpg";